import { DynamicObjectInterface, ImageReturnType } from '@commerce-profile-webcomponents/sdk';
import type { Step } from '@commerce-profile-webcomponents/sdk';
import { Theme } from '@nextgen-web-framework/all';
import { APICallType, NextHandlerProps } from '../../Registration/types/propTypes';

export interface ExtendedStep extends Step {
  [x: string]: DynamicObjectInterface;
}

export interface CoAppCommonProps {
  nextHandler?: (
    payload?: NextHandlerProps,
    slicePayload?: DynamicObjectInterface,
    stayOnSameStep?: boolean,
    callOnSuccess?: boolean,
    apiCallType?: APICallType,
  ) => DynamicObjectInterface;
  idStepIsLanding?: boolean;
}

export interface CoAppCommonScreenProps {
  buttonHandler?: () => void;
  screenType: CoAppScreenEnum;
  buttonLoading?: boolean;
  disableButton?: boolean;
  buttonMessage?: string;
  buttonMessageTheme?: Theme;
}

export interface CoAppDisplayItem {
  image?: ImageReturnType;
  iconChecked?: boolean;
  height?: number;
  altTxt?: string;
  headerTxt?: string;
  subHeaderTxt1?: string;
  subHeaderTxt2?: string;
  buttonTxt?: string;
}

// To show screen type based on step
export enum CoAppScreenEnum {
  NONE = '',
  OTP_VERIFY = 'OTP_VERIFY',
  PENDING = 'PENDING',
  INVITATION_SENT = 'INVITATION_SENT',
  COMPLETED = 'COMPLETED',
}
